import get from 'lodash/get';
import { getUserCounterValidEmail } from 'services/api/user/counterValidEmail';
import { getModify } from 'services/api/user/modify';
import {
  IP_TELMEX_UPDATE_EMAIL_OPEN_MODAL,
  IP_TELMEX_UPDATE_EMAIL_CLOSE_MODAL,
  IP_TELMEX_SET_ERROR,
  IP_TELMEX_SET_LOADING,
  IP_TELMEX_SET_PHONE,
} from 'actions/ip_telmex';
import { setUserModify } from './user';

export const openModal = next => ({
  type: IP_TELMEX_UPDATE_EMAIL_OPEN_MODAL,
  payload: { isOpen: true, next },
});

export const closeModal = () => ({
  type: IP_TELMEX_UPDATE_EMAIL_CLOSE_MODAL,
  payload: { isOpen: false },
});

export const setError = data => ({
  type: IP_TELMEX_SET_ERROR,
  payload: data,
});

export const setLoading = isLoading => ({
  type: IP_TELMEX_SET_LOADING,
  payload: isLoading,
});

const setPhone = phone => ({
  type: IP_TELMEX_SET_PHONE,
  payload: phone,
});

export const getCounterValidEmail = (count = 3, next) => dispatch => {
  const params = { userhash: localStorage.getItem('loginInfo.userhash') };
  return getUserCounterValidEmail(params)
    .then(r => {
      const valid = get(r, 'response.validEmail');
      const counter = get(r, 'response.counterValidEmail');
      const phone = get(r, 'response.userDetectWS.tlf', '');
      dispatch(setPhone(phone));
      if (!valid && counter <= count) {
        dispatch(openModal(next));
        return true;
      }
      dispatch(closeModal());
      return false;
    })
    .catch(closeModal);
};

export const userModify = (data, next) => async dispatch => {
  const entry = data;
  dispatch(setLoading(true));
  const result = await getModify(data);
  dispatch(setLoading(false));
  const status = get(result, 'response.status', get(result, 'status', '1'));
  if (status !== '0')
    dispatch(setError(result.response && result.response.error));
  else {
    dispatch(closeModal());
    dispatch(setUserModify(entry));
    next && next();
  }
};
